import { Component } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"

import { capitalize } from "humanize-plus"

import thumbsUp from "images/partners/feedback/thumbs-up.svg?raw"
import thumbsDown from "images/partners/feedback/thumbs-down.svg?raw"

class AppletFeedback extends Component {
  dislikePercent = count => {
    try {
      return Math.round(
        (count / this.props.applet_feedback_count.dislike) * 100
      )
    } catch (err) {
      return 0
    }
  }

  dislikeString = code => {
    let string = ""
    if (code == "unexpected") {
      string = "doesn't work as expected"
    } else if (code == "no_response") {
      string = "no reason given"
    } else {
      string = code
    }
    string = capitalize(string)
    string = string.replace("_", " ")
    return string
  }

  render() {
    const {
      applet_feedback_count,
      applet_opinion_count,
      negative_rating_percentage,
      docs_applets_path,
      positive_rating_percentage,
      tip_subtitle,
      tip_title,
      tips_list,
    } = this.props
    return (
      <div className="applet-feedback-container">
        <div className="ratings-side">
          <div className="applet-feedback-rating expanded">
            <div className="thumbs-container">
              <div className="positive-ratings">
                <h3 className="rating-description">Thumbs up</h3>
                <div className="rating-container">
                  <span className="thumbs up">{parse(thumbsUp)}</span>
                  <span className="thumb-count">
                    {applet_feedback_count.like}
                  </span>
                </div>
              </div>
              <div className="vertical-divider" />
              <div className="negative-ratings">
                <h3 className="rating-description">Thumbs down</h3>
                <div className="rating-container">
                  <span className="thumbs down">{parse(thumbsDown)}</span>
                  <span className="thumb-count">
                    {applet_feedback_count.dislike}
                  </span>
                </div>
              </div>
            </div>
            <div className="rating-bar">
              <span
                className={`positive-rating-bar ${
                  this.props.positive_rating_percentage > 0 ? "" : "zero"
                }`}
                style={{
                  width: `${positive_rating_percentage}%`,
                }}
              >
                <span>
                  {positive_rating_percentage > 0
                    ? `${parseInt(positive_rating_percentage)}%`
                    : ""}
                </span>
              </span>
              <span
                className={`negative-rating-bar ${
                  this.props.negative_rating_percentage > 0 ? "" : "zero"
                }`}
                style={{
                  width: `${negative_rating_percentage}%`,
                }}
              >
                <span>
                  {negative_rating_percentage > 0
                    ? `${parseInt(negative_rating_percentage)}%`
                    : ""}
                </span>
              </span>
            </div>
          </div>
          <div className="reasons-divider" />
          <h4>Thumbs down reasons</h4>
          <div className="thumbs-down-reasons expanded">
            {Object.entries(applet_opinion_count).map((opinion, idx) => {
              return (
                <div key={idx} className="reason">
                  <span>{this.dislikeString(opinion[0])}</span>
                  <span className="outer-bar">
                    <span
                      className="inner-bar"
                      style={{ width: `${this.dislikePercent(opinion[1])}%` }}
                    >
                      <span>
                        {!isNaN(this.dislikePercent(opinion[1])) &&
                          `${this.dislikePercent(opinion[1])}%`}
                      </span>
                    </span>
                  </span>
                  <span className="count">{opinion[1]}</span>
                </div>
              )
            })}
          </div>
        </div>
        <div className="tips-side">
          <h3 className="twenty-eight">{tip_title}</h3>
          <h4>{tip_subtitle}:</h4>
          <div>
            <ol>
              {tips_list.map((tip, idx) => {
                return (
                  <li key={idx} className="tip">
                    <p>{parse(tip)}</p>
                  </li>
                )
              })}
            </ol>
            <a
              href={docs_applets_path}
              className="button-secondary"
              target="_blank"
              rel="noreferrer"
            >
              View Guide
            </a>
          </div>
        </div>
      </div>
    )
  }
}

AppletFeedback.propTypes = {
  tip_title: PropTypes.string.isRequired,
  tip_subtitle: PropTypes.string.isRequired,
  tips_list: PropTypes.array.isRequired,
  docs_applets_path: PropTypes.string.isRequired,
  applet_feedback_count: PropTypes.object.isRequired,
  positive_rating_percentage: PropTypes.number.isRequired,
  negative_rating_percentage: PropTypes.number.isRequired,
  applet_opinion_count: PropTypes.object.isRequired,
}

export default AppletFeedback
